import { Link, NavLink, Outlet, useParams } from 'react-router';
import { currentEmail, signOut } from '../auth';
import { Logo } from '../components/Logo';
import { useLive } from './queries';

export function RaceLayout() {
  const { raceId = '' } = useParams();
  const live = useLive(raceId);
  const reviewOpen = live.data?.counts.reviewOpen ?? 0;
  const email = currentEmail();

  return (
    <>
      <header className="bar">
        <div className="bar-inner">
          <Link to="/" className="brand">
            <Logo />
            <span>Splitline</span>
          </Link>
          <nav aria-label="Primary" className="nav">
            <NavLink to={`/races/${raceId}`} end>
              Race day
            </NavLink>
            <NavLink to={`/races/${raceId}/roster`}>Roster</NavLink>
            <NavLink to={`/races/${raceId}/course`}>Course &amp; stations</NavLink>
            <NavLink to={`/races/${raceId}/review`}>
              Results &amp; review {reviewOpen > 0 && <span className="badge">{reviewOpen}</span>}
            </NavLink>
            <NavLink to={`/races/${raceId}/team`}>Team</NavLink>
          </nav>
          <div className="bar-right">
            <Link to="/help" style={{ color: 'var(--bar-muted)' }}>
              Help
            </Link>
            <span>{live.data?.race.name ?? ''}</span>
            <button
              type="button"
              className="btn link"
              style={{ color: 'var(--bar-muted)' }}
              onClick={() => {
                signOut();
                location.assign('/login');
              }}
              title={email ?? undefined}
            >
              Sign out
            </button>
          </div>
        </div>
      </header>
      <Outlet />
    </>
  );
}
